import {Component, OnInit} from '@angular/core';
import {
  HISTORY_KEY_SEARCH_SAJASEUNGEO,
  SearchParam
} from 'src/app/shared/defines/client.const';
import {WordComponent} from "../word.component";
import {WordBookmarkService} from "../../shared/services/word/word-bookmark.service";
import {WordService} from "../../shared/services/word/word.service";
import {SajaseungeoBookmarkService} from "../../shared/services/word/sajaseungeo-bookmark.service";
import {SajaseungeoWordService} from "../../shared/services/word/sajaseungeo-word.service";

@Component({
  selector: 'app-sajaseungeo',
  templateUrl: './../word.component.html',
  styleUrls: ['./sajaseungeo.component.scss'],
  providers: [
    {
      provide: WordService,
      useClass: SajaseungeoWordService,
    },
    {
      provide: WordBookmarkService,
      useClass: SajaseungeoBookmarkService,
    },
  ],
})
export class SajaseungeoComponent extends WordComponent {
  public jasoIdxSecond = false;
  public HistoryKeySearchWord = HISTORY_KEY_SEARCH_SAJASEUNGEO;
  protected thisPageAddr = '/sajaseungeo';

  /** 검색 입력 필드에 표시되는 placeholder 텍스트 */
  public placeholder = '사 자 성어를 검색 합니다.';
  /** 검색 결과가 없을 때 표시되는 메시지 */
  protected noResultTxt = '사 자 성어가 없습니다.';

  protected showLevel = false;

  protected isOptionWordLevelAll() {
    return true;
  }

  protected modParam(param: SearchParam): SearchParam {
    return {
      ...param,
      saja: 1,
    }
  }

  protected setLastId(detail_id: string | null, list_id: string | null) {
    this.lastIdSvc.setLastSajaseungeoId(detail_id, list_id);
  }

  protected clearLastId() {
    this.lastIdSvc.clearLastSajaseungeoId();
  }
}
